import pathsManifest from 'app/shared/pathsManifest';
import queryUtils from 'app/shared/utils/queryUtils';
import StringConstants from 'app/shared/constants/StringConstants';
import QueryConstants from 'app/shared/constants/QueryConstants';

const contextUtils = {
    getPageContext(labelPrefix = '') {
        if (__CLIENT__) {
            const pathname = window.location.pathname;
            const pathList = pathsManifest.getAllPaths();

            let response = labelPrefix;

            const isLeadPath = pathname && pathname.indexOf(pathList.leadPage) > -1;
            const isPropertyDetailsListing = pathname && pathname.indexOf(pathList.propertyDetailsListing) > -1;

            if (isLeadPath) {
                response += 'Lead';
            }

            if (isPropertyDetailsListing) {
                response += 'Listing Post Activation';
            }

            return response;
        }
        return '';
    },

    /**
     * Gets the marketing path value
     *
     * @param {string} search - The search query params
     * @return {string}
     */
    getMarketingPathVal(search) {
        const queryParams = queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH];
    },

    /**
     * Checks if the marketing search query parameter is application.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingApplicationsRoute(search) {
        const queryParams = queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.APPLICATIONS;
    },

    /**
     * Checks if the marketing search query parameter is payment.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingPaymentsRoute(search) {
        const queryParams = queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.PAYMENTS;
    },

    /**
     * Checks if the marketing search query parameter is leases.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingLeasesRoute(search) {
        const queryParams = queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.LEASES;
    },
};

export default contextUtils;
